<template>
  <v-container class="pa-4 pa-md-10">
    <!-- Container Title -->
    <div class="d-flex flex-column pa-4 pa-md-10">
      <div class="title-large pb-4">
        {{ texts.settings.title }} {{ $store.state.sFullName }}
      </div>
      <div class="text-body">
        {{ texts.settings.subtitle }}
      </div>
    </div>

    <!-- Container Options -->
    <div class="pa-4 pa-md-10">
      <!-- Email two factor -->
      <div
        class="d-flex align-center row-option"
        :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'"
      >
        <div class="icon-container mr-md-4 mb-2 mb-md-0">
          <v-icon
            :size="$vuetify.breakpoint.smAndDown ? 32 : 50"
            color="#193D6E"
            >mdi-shield-lock</v-icon
          >
        </div>
        <div class="d-flex flex-column px-0 px-md-10 flex-grow-1 w-100">
          <div class="title-medium">{{ texts.settings.emailTwoFactor.title }}</div>
          <div class="text-body-secondary pt-2">
            {{ texts.settings.emailTwoFactor.subtitle }}
          </div>
        </div>
        <div class="button-col mt-2 mt-md-0 w-100 w-md-auto">
          <v-btn
            color="#0075B8"
            outlined
            size="small"
            rounded
            elevation="5"
            style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            min-width="220"
            :disabled="!email"
            class="no-uppercase w-100 w-md-auto"
            @click="openModalEmailTwoFactor"
          >
            {{ texts.settings.emailTwoFactor.buttonText }}
          </v-btn>
        </div>
      </div>

      <div class="py-4 py-md-8"></div>

      <!-- Reset password -->
      <div
        class="d-flex align-center row-option"
        :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'"
      >
        <div class="icon-container mr-md-4 mb-2 mb-md-0">
          <v-icon
            :size="$vuetify.breakpoint.smAndDown ? 32 : 50"
            color="#193D6E"
            >mdi-lock</v-icon
          >
        </div>
        <div class="d-flex flex-column px-0 px-md-10 flex-grow-1 w-100">
          <div class="title-medium">{{ texts.settings.resetPassword.title }}</div>
          <div class="text-body-secondary pt-2">
            {{ texts.settings.resetPassword.subtitle }}
          </div>
        </div>
        <div class="button-col mt-2 mt-md-0 w-100 w-md-auto">
          <v-btn
            color="#0075B8"
            outlined
            size="small"
            rounded
            style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            elevation="5"
            min-width="220"
            class="no-uppercase w-100 w-md-auto"
            @click="openModalResetPassword"
          >
            {{ texts.settings.resetPassword.buttonText }}
          </v-btn>
        </div>
      </div>

      <div class="py-4 py-md-8"></div>

      <!-- Users -->
      <div
        class="d-flex align-center row-option"
        :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'"
      >
        <div class="icon-container mr-md-4 mb-2 mb-md-0">
          <v-icon
            :size="$vuetify.breakpoint.smAndDown ? 32 : 50"
            color="#193D6E"
            >mdi-account-circle-outline</v-icon
          >
        </div>
        <div class="d-flex flex-column px-0 px-md-10 flex-grow-1 w-100">
          <div class="title-medium">{{ texts.settings.users.title }}</div>
          <div class="text-body-secondary pt-2">
            {{ texts.settings.users.subtitle }}
          </div>
        </div>
        <div class="button-col mt-2 mt-md-0 w-100 w-md-auto">
          <v-btn
            color="#0075B8"
            outlined
            size="small"
            rounded
            style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            min-width="220"
            :disabled="!email"
            elevation="5"
            class="no-uppercase w-100 w-md-auto"
            @click="openModalUsers"
          >
            {{ texts.settings.users.buttonText }}
          </v-btn>
        </div>
      </div>

      <div class="py-4 py-md-8"></div>

      <!-- Account statement -->
      <div
        class="d-flex align-center row-option"
        :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'"
      >
        <div class="icon-container mr-md-4 mb-2 mb-md-0">
          <v-icon
            :size="$vuetify.breakpoint.smAndDown ? 32 : 50"
            color="#193D6E"
            >mdi-file-document-outline</v-icon
          >
        </div>
        <div class="d-flex flex-column px-0 px-md-10 flex-grow-1 w-100">
          <div class="title-medium">{{ texts.settings.accountStatement.title }}</div>
          <div class="text-body-secondary pt-2">
            {{ texts.settings.accountStatement.subtitle }}
          </div>
        </div>
        <div class="button-col mt-2 mt-md-0 w-100 w-md-auto">
          <v-btn
            color="#0075B8"
            outlined
            size="small"
            rounded
            min-width="220"
            elevation="5"
            style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            class="no-uppercase w-100 w-md-auto"
            @click="openModalAccountStatement"
          >
            {{ texts.settings.accountStatement.buttonText }}
          </v-btn>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <DialogUsers
      v-model="showDialogUsers"
      :users="users"
      :texts="texts"
      @add-user="openUserForm"
      @delete-user="deleteUser"
      @user-created="createUser"
      @refresh-users="fetchUsers"
    />
    <DialogEmailTwoFactor
      v-model="showDialogEmailTwoFactor"
      :email="email"
      :mode="isEmailRegistered ? 'edit' : 'setEmail'"
      :texts="texts"
      @refresh="getDataAuth"
    />
    <DialogResetPassword
      v-model="showDialogResetPassword"
      :texts="texts"
    />
    <DialogAccountStatement
      v-model="showDialogAccountStatement"
      :texts="texts"
    />
  </v-container>
</template>

<script>
import DialogUsers from "./dialogs/DialogUsers.vue";
import DialogEmailTwoFactor from "./dialogs/DialogEmailTwoFactor.vue";
import DialogResetPassword from "./dialogs/DialogResetPassword.vue";
import DialogAccountStatement from "./dialogs/DialogAccountStatement.vue";

export default {
  name: "Security",
  components: {
    DialogUsers,
    DialogEmailTwoFactor,
    DialogResetPassword,
    DialogAccountStatement
  },
  data() {
    return {
      dashboardItems: [],
      isLoading: false,
      texts: {},
      email: "",
      isEmailRegistered: false,
      showDialogUsers: false,
      showDialogEmailTwoFactor: false,
      showDialogResetPassword: false,
      showDialogAccountStatement: false,
      users: [],
      userFormDialog: false,
      userForm: {
        sName: "",
        sLastname: "",
        sEmail: "",
        sPassword: "",
        sConfirmPassword: ""
      },
      userFormValid: false,
      showUserPassword: false
    };
  },

  methods: {
    async getDashboard() {
      try {
        this.loading = true;

        const response = await DB.get(
          `${URI}/api/v1/${this.selectLanguage}/dashboard`,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        );

        const data = response.data;
        this.dashboardItems = data;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }

        this.stopDashboardRateTimer();
      }
    },
    getDataAuth() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/authenticator/getData`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
        .then((response) => {
          if (!response.data.success) {
            this.mixError(response.data.message, response.status);
          }
          this.email = response.data.data.sAuthEmail.sEmail;
          this.isEmailRegistered = response.data.data.sAuthEmail.bEnabled;
          this.resetForm();
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    fetchUsers() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/users/usersByEnterpriseId`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
        .then((response) => {
          if (response.data.success) {
            this.users = response.data.results.map((user) => ({
              sUserId: user.sUserId,
              sName: user.sName,
              sLastname: user.sLastname,
              sEmail: user.sEmail,
              bActive: user.bActive,
              sPhoneNumber: user.sPhoneNumber || "",
              bPlatformAccess: user.bPlatformAccess,
              tCreatedAtView: user.tCreatedAtView
            }));
          } else {
            this.users = [];
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    openModalUsers() {
      this.fetchUsers();
      this.showDialogUsers = true;
    },
    openModalEmailTwoFactor() {
      this.getDataAuth();
      this.showDialogEmailTwoFactor = true;
    },
    openModalResetPassword() {
      this.showDialogResetPassword = true;
    },
    openModalAccountStatement() {
      this.showDialogAccountStatement = true;
    },
    openUserForm() {
      this.userForm = {
        sName: "",
        sLastname: "",
        sEmail: "",
        sPassword: "",
        sConfirmPassword: ""
      };
      this.userFormDialog = true;
    },
    async createUser(user) {
      if (
        !user.sName ||
        !user.sLastname ||
        !user.sEmail ||
        !user.sPassword ||
        user.sPassword !== user.sConfirmPassword
      ) {
        this.mixError(
          "Completa todos los campos y asegúrate que las contraseñas coincidan"
        );
        return;
      }
      try {
        const payload = {
          sName: user.sName,
          sLastname: user.sLastname,
          sEmail: user.sEmail,
          sPassword: user.sPassword
        };
        const response = await DB.post(
          `${URI}/api/v1/${this.selectLanguage}/users/createUser`,
          payload,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        );
        if (response.data.success) {
          this.mixSuccess(response.data.message);
          this.fetchUsers();
        } else {
          this.mixError(response.data.message);
        }
      } catch (error) {
        this.mixError(
          error.response?.data?.message || "Error al crear usuario"
        );
      }
    },
    async deleteUser(user) {
      try {
        const response = await DB.patch(
          `${URI}/api/v1/${this.selectLanguage}/users/disable`,
          { sUserId: user.sUserId },
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        );
        if (response.data.success) {
          this.mixSuccess("Usuario deshabilitado correctamente");
          this.fetchUsers();
        } else {
          this.mixError(response.data.message);
        }
      } catch (error) {
        this.mixError(
          error.response?.data?.message || "Error al deshabilitar usuario"
        );
      }
    }
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getDataAuth();
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
    }
  },
  computed: {
    selectLanguage() {
      return this.$store.state.language;
    }
  }
};
</script>

<style scoped>
.title-large {
  font-family: "montserrat-semibold";
  font-size: 24px;
  font-weight: 600;
  color: #193d6e;
}

.text-body {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 400;
  color: #737583;
}

.text-body-large {
  font-family: "montserrat-regular";
  font-weight: 400;
  font-size: 10px;
  color: #000000;
}

.title-medium {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: 0%;
  color: #000000;
}

.text-body-secondary {
  font-family: "montserrat-regular";
  font-size: 12px;
  font-weight: 400;
  color: #000000;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  min-width: 80px;
  min-height: 80px;
  border-radius: 50%;
  background-color: #d9d9d9;
}

.no-uppercase {
  text-transform: none !important;
}

.row-option {
  min-height: 100px;
  align-items: center;
}

.row-option > div:last-child {
  display: flex;
  align-items: center;
  height: 100%;
}

.v-btn {
  height: 48px;
  display: flex;
  align-items: center;
}

.flex-grow-1 {
  flex-grow: 1;
}

.button-col {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 10vh;
  min-width: 220px;
}

@media (max-width: 960px) {
  .pa-md-10 {
    padding: 40px !important;
  }
  .px-md-10 {
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
  .py-md-8 {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }
}

@media (max-width: 600px) {
  .title-large {
    font-size: 18px;
  }
  .title-medium {
    font-size: 14px;
  }
  .text-body,
  .text-body-secondary {
    font-size: 12px;
  }
  .icon-container {
    width: 56px;
    height: 56px;
    min-width: 56px;
    min-height: 56px;
    margin-bottom: 8px;
  }
  .row-option {
    flex-direction: column !important;
    align-items: flex-start !important;
    min-height: unset;
    padding: 16px 0;
  }
  .button-col {
    margin-right: 0;
    min-width: 100%;
    width: 100%;
    justify-content: flex-start;
    margin-top: 12px;
  }
  .pa-4 {
    padding: 16px !important;
  }
  .px-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .w-100 {
    width: 100% !important;
  }
  .w-md-auto {
    width: auto !important;
  }
  .v-dialog__content {
    max-width: 95vw !important;
  }
  .v-card {
    padding: 8px !important;
  }
}
</style>
